module.exports = '/ng-templates/exemplar-status/exemplar-statuses.tpl.ftl';
